"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicSearchCountryFaqClient = void 0;
const model_client_1 = require("../../model-client");
class PublicSearchCountryFaqClient extends model_client_1.ModelClient {
    getModelName() {
        return 'search-country-faq';
    }
    getVersion() {
        return 'v1';
    }
    isPublic() {
        return true;
    }
}
exports.PublicSearchCountryFaqClient = PublicSearchCountryFaqClient;
//# sourceMappingURL=public-search-country-faq-client.js.map